import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BASE_COLOR } from 'shared/constants/colors';
import { overlayOpenStartMenu } from 'shared/actions/view/web';
import { compose } from 'shared/helpers';

import {
  FontIcon,
  DiamondButton,
} from 'components/elems';


const EnterIcon = () => (
  <FontIcon
    type="enter"
    className="b"
    style={{
      color: BASE_COLOR.white,
      fontSize: '18px',
      marginRight: '2px',
    }}
  />
);


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    overlayOpenStartMenu,
  }, dispatch);
}


const AuthActionControlGroup = (props) => {
  // XXX(thx): At preview launch, we aren't going to
  // actually sign up people, just collect emails so hide
  // start menu.
  const { lolHideSelf = true } = props;
  if (lolHideSelf) {
    return null;
  }

  return (
    <div>
      <DiamondButton
        icon={<EnterIcon />}
        outerStyle={{
          animation: 'DiamondButton-little-bounce 100ms forwards'
        }}
        color={BASE_COLOR.hotPink}
        size={42}
        onClick={props.overlayOpenStartMenu}
      />
    </div>
  );
};


export default compose(
  connect(null, mapDispatchToProps),
)(AuthActionControlGroup);



// WEBPACK FOOTER //
// ./src/components/navs/_navbar/AuthActionControlGroup.js